import React, { useState } from 'react';
import CenterContent from './../Components/CenterContent/CenterContent';
import InstrumentsWrrapper from './../Components/InstrumentsWrrapper/InstrumentsWrrapper';
import AdditionAcadem from './../block/addition/AdditionAcadem';
import AdditionDop from './../block/addition/AdditionDop';
import { direction } from './../store/direction';
import { observer } from 'mobx-react-lite';
import { FiEdit } from 'react-icons/fi';
import AcademModal from './../Components/Modal/Addition/AcademModal';
import http from './../Service/http';
import { useEffect } from 'react';
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useTranslation } from 'react-i18next';


function DirectoryContaier() {

    const { t } = useTranslation();
    const [ modal, setModal ] = useState<{
        modal: boolean
        stud: any
      }>({
        modal: false,
        stud: {}
    })

    const closeModalNotes = () => { 
        setModal({
            modal: false,
            stud: null
        })
    }

    const [ page, setPage ] = useState<number>(1)

    const getDirection =async (params:number = 1) => {
        if(direction.sdd == 1){
            const res = await http.get("/addition/direction?search_direction=" + "" + "&pageNum=" + params)  
            direction.newAcadem(res.data.DirectionList);
            return
        }else if(direction.sdd == 2){
            const res = await http.get("/addition/special?search_direction=" + "" + "&pageNum=" + params)
            direction.newAcadem(res.data.SpecialList);
            return
        }else if(direction.sdd == 3){
            const res = await http.get("/addition/discipline?search_direction=" + "" + "&pageNum=" + params)
            direction.newAcadem(res.data.DisciplineList);
            return
        }
        
    }

    useEffect(() => {
        getDirection(page)
        direction.setPage(page)
    }, [page])

    return ( 
        <>
            <CenterContent>
                <AcademModal setIsOpen={closeModalNotes} isOpen={modal.modal} stud={modal.stud} />
                <InstrumentsWrrapper
                    leftHead={t("st:instrument.titles.directoryRight")}
                    rightHead={t("st:instrument.titles.directoryLeft")}
                    leftChilds={<AdditionDop/>}
                    rightChilds={<AdditionAcadem setPage={setPage}/>}
                    leftIcon= {<></>}
                    rightIcon= {<></>}
                />
                <div className="academ_pages" >
                    <div className="academ_btns">
                        {
                            (direction.leftOrRight == "right" && direction.academ[0]?.pageStart) ? <>
                                <button style={{marginRight: 12}} className='academ_btn' onClick={() => {
                                if(page > 1){
                                    setPage(page - 1)
                                }
                                }} ><MdOutlineKeyboardArrowLeft className='academ_btn_icon' /></button>
                                {
                                    direction.academ[0]? direction.academ[0].pageStart + "-" + direction.academ[0].pageEnd + "/" + direction.academ[0].total: ''
                                }
                                <button className='academ_btn' onClick={() => {
                                    if(direction.academ[direction.academ.length - 1].rowNum == direction.academ[direction.academ.length - 1].total) return
                                    setPage(page + 1)
                                }} ><MdOutlineKeyboardArrowRight className='academ_btn_icon' /></button>
                            </>
                            : ""
                        }
                    </div>
                </div>
                <div className="TableWrapper">
                    <table>
                        <thead>
                            
                            {
                                direction.leftOrRight !== "right"? <tr>
                                    <th style={{ width: '5%' }}>№</th>
                                    <th style={{ width: '30%', textAlign: 'left' }}>{"Справка"}</th>
                                    <th style={{ width: '30%' }}>{"На русском"}</th>
                                    <th style={{ width: '30%' }}>{"Кыргызча"}</th>
                                    <th style={{ width: '5%', maxWidth: '120px' }}>{"Изменить"}</th>
                                </tr>
                                :
                                <tr>
                                    <th style={{ width: '5%' }}>№</th>
                                    <th style={{ width: '30%', textAlign: 'left' }}>{"На русском"}</th>
                                    <th style={{ width: '30%' }}>{"Кыргызча"}</th>
                                    <th style={{ width: '30%' }}>{"English"}</th>
                                    <th style={{ width: '5%', maxWidth: '120px' }}>{"Изменить"}</th>
                                </tr>
                            }
                        </thead>
                        <tbody>
                            {   direction.leftOrRight == "right" ? 
                                direction.academ.map((item, index) => {
                                    // if(item){
                                    //     return (
                                    //         <tr className="active_line" key={index} onClick={() => {
                                    //         }}>
                                    //             <td>{index + 1}</td>
                                    //             <td style={{ textAlign: 'left' }}>{item.p24}</td>
                                    //             <td>{item.p24_kg}</td>
                                    //             <td>{item.p24_en}</td>
                                    //             <td>
                                    //                 <FiEdit  style={{ color: '#aaa', fontSize: '18px', fontWeight: 'bold' }} onClick={() => {
                                    //                     setModal({
                                    //                     modal: true,
                                    //                     stud: item
                                    //                     })
                                    //                 }}/>
                                    //             </td>
                                    //         </tr>
                                    //     )
                                    // }
                                    return (
                                        <tr key={index} onClick={() => {
                                        }}>
                                        <td>{index + 1}</td>
                                        <td style={{ textAlign: 'left' }}>{item.p24}</td>
                                        <td>{item.p24_kg}</td>
                                        <td>{item.p24_en}</td>
                                        <td>
                                            <FiEdit  style={{ color: '#aaa', fontSize: '18px', fontWeight: 'bold' }} onClick={() => {
                                                setModal({
                                                modal: true,
                                                stud: item
                                                })
                                            }}/>
                                        </td>
                                        </tr>
                                    )
                                }):
                                direction.dops.map((item, index) => {
                                    if(item.id_okno_dopolnitelno == modal.stud?.id){
                                        return (
                                            <tr key={index} className="active_line" onClick={() => {
                                                }}>
                                                <td>{index + 1}</td>
                                                <td style={{ textAlign: 'left' }}>{item.coment}</td>
                                                <td>{item.insert_pole}</td>
                                                <td>{item.insert_pole_kg}</td>
                                                <td>
                                                <FiEdit  style={{ color: '#aaa', fontSize: '18px', fontWeight: 'bold' }} onClick={() => {
                                                    setModal({
                                                        modal: true,
                                                        stud: item
                                                    })
                                                }}/>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    return (
                                        <tr key={index} onClick={() => {
                                            }}>
                                            <td>{index + 1}</td>
                                            <td style={{ textAlign: 'left' }}>{item.coment}</td>
                                            <td>{item.insert_pole}</td>
                                            <td>{item.insert_pole_kg}</td>
                                            <td>
                                            <FiEdit  style={{ color: '#aaa', fontSize: '18px', fontWeight: 'bold' }} onClick={() => {
                                                setModal({
                                                    modal: true,
                                                    stud: item
                                                })
                                            }}/>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </CenterContent>
        </>
     );
}

export default observer(DirectoryContaier);